import React, { Component } from 'react'
import _ from 'lodash'
import { CATEGORIES } from '../../constants'
import SliderActivities from './SliderActivities'
import { observer } from 'mobx-react'
import searchStore from '../../mobx-store/search-store'
import R from 'ramda'
import moment from 'moment'

class AllActivities extends Component {
  getCategoriesOptions = () => {
    const options = []
    for (let key in CATEGORIES) {
      options.push({ label: key, value: key })
    }
    return options
  }

  render() {
    const { localTours, tripGurus, featuredDestinations } = this.props
    return (
      <div className="main-container">
        {!searchStore.pickedPlace.country &&
          !searchStore.rangeDate.endDate && (
            <SliderActivities
              collection={_.get(featuredDestinations, 'allContentPOIs', []).slice(0, 10)}
              type={'destination'}
              title={'Featured Destinations'}
            />
          )}
        <SliderActivities
          collection={
            tripGurus.user &&
            tripGurus.user
              .filter(
                guru =>
                  guru.plannerProfile && guru.plannerProfile.languages && guru.plannerProfile.categories && guru.plannerProfile.expertises
              )
              .filter(
                item =>
                  !!R.contains(searchStore.pickedPlace.country, item.plannerProfile.locations.map(item => item.country)) ||
                  !searchStore.pickedPlace.country
              )
              /*
              .filter(
                item =>
                  !searchStore.rangeDate.startDate ||
                  !searchStore.rangeDate.endDate ||
                  item.customizedPlans.reduce(
                    (acc, item) =>
                      moment(item.startDate).diff(searchStore.rangeDate.startDate) >= 0 &&
                      moment(item.endDate).diff(searchStore.rangeDate.endDate) <= 0
                        ? true
                        : acc,
                    false
                  )
              )
              */
              .slice(0, 10)
          }
          country={searchStore.pickedPlace.country}
          type={'plan'}
          title={'Trip Guru'}
          dateRange={searchStore.rangeDate}
        />
        <SliderActivities
          collection={localTours.localTour
            .filter(tour => tour)
            .filter(
              tour =>
                (_.get(tour, 'tourLocation.country', '') === searchStore.pickedPlace.country || !searchStore.pickedPlace.country) &&
                (_.get(tour, 'tourLocation.city', '') === searchStore.pickedPlace.city || !searchStore.pickedPlace.city)
            )
            .slice(0, 10)}
          type={'tour'}
          title={'Guided Activities'}
        />
      </div>
    )
  }
}

export default observer(AllActivities)



// WEBPACK FOOTER //
// src/components/homepage/AllActivitiesComponent.js